import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiSearch, FiLayers, FiTool, FiUsers, FiBarChart2, FiRefreshCw } = FiIcons;

const steps = [
  {
    icon: FiSearch,
    num: '01',
    label: 'Assess',
    desc: 'We map your current asset tracking and support request flow — what tools exist, where data lives, and where things break down.',
  },
  {
    icon: FiLayers,
    num: '02',
    label: 'Design the System',
    desc: 'We design your JSM environment: asset schema, request types, queues, SLAs, and the routing logic that matches how your team actually works.',
  },
  {
    icon: FiTool,
    num: '03',
    label: 'Build & Deploy',
    desc: 'We stand up the system, migrate your existing asset data, configure automations, and get your team live — typically in 4–6 weeks.',
  },
  {
    icon: FiUsers,
    num: '04',
    label: 'Train Your Team',
    desc: 'We walk your ops and IT staff through the system so they can submit requests, update assets, and manage queues without needing to call us.',
  },
  {
    icon: FiBarChart2,
    num: '05',
    label: 'Visibility from Day One',
    desc: 'From go-live, managers have a real dashboard — open tickets, asset status, SLA performance, and which sites are generating the most volume.',
  },
  {
    icon: FiRefreshCw,
    num: '06',
    label: 'Retainer Support',
    desc: 'We stay on as your JSM admin. New asset types, workflow changes, new locations — handled on retainer without spinning up a new project every time.',
  },
];

const HomeHowItWorks = () => (
  <section id="how-it-works" className="py-24" style={{ background: '#ffffff' }}>
    <div className="max-w-5xl mx-auto px-8 lg:px-16">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-14">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#16a34a' }}>How It Works</p>
        <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#052e16' }}>
          From spreadsheet chaos to a system that works.
        </h2>
        <p className="text-sm max-w-xl leading-relaxed" style={{ color: '#166534' }}>
          We run a structured engagement — assessment, build, go-live — and stay on retainer so the system evolves with your operation instead of becoming the next thing you have to fix.
        </p>
      </motion.div>
      <div className="grid md:grid-cols-3 gap-5">
        {steps.map((s, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ delay: i * 0.07 }}
            className="p-6 rounded-xl border" style={{ background: '#f0fdf4', borderColor: '#bbf7d0' }}>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: '#dcfce7' }}>
                <SafeIcon icon={s.icon} className="w-4 h-4" style={{ color: '#16a34a' }} />
              </div>
              <span className="text-2xl font-bold" style={{ color: '#bbf7d0' }}>{s.num}</span>
            </div>
            <h3 className="text-base font-bold mb-2" style={{ color: '#052e16' }}>{s.label}</h3>
            <p className="text-sm leading-relaxed" style={{ color: '#166534' }}>{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default HomeHowItWorks;